import { Controller } from "@hotwired/stimulus";
export default class default_1 extends Controller {
    constructor() {
        super(...arguments);
        this.isDTInitialized = false;
    }
    get table() {
        if (this.element instanceof HTMLTableElement) {
            return this.element;
        }
        if (this.hasTableTarget && this.tableTarget instanceof HTMLTableElement) {
            return this.tableTarget;
        }
        throw new Error('This controller\'s element is not an HTMLTableElement and there is not compatible "table" target defined.');
    }
    connect() {
        if ($.fn.dataTable.isDataTable(this.table)) {
            this.isDTInitialized = true;
        }
        else {
            const columns = [
                {
                    data: "id",
                    visible: false,
                },
                {
                    data: "name",
                },
                {
                    data: "logo",
                    render: (value, type, row) => {
                        if (type === "display") {
                            if (value === null) {
                                return "Sin logo";
                            }
                            // this would be the base64 data for the image
                            return `<img class="${this.imagePreviewClass}"
                                         src="data:image/*;base64,${value}"
                                         alt="${row.name} Logo">`;
                        }
                        return value;
                    },
                    orderable: false,
                    searchable: false,
                    visible: false,
                },
                {
                    data: null,
                    render: (data, type) => {
                        if (type === "display") {
                            // considering using an actions-template-value for this...
                            // doing this for now
                            const deleteAction = `${this.application.schema.actionAttribute}="${this.identifier}#requestDelete:stop"`;
                            const params = `data-${this.identifier}-id-param="${data.id}"`;
                            return `<div class="d-flex flex-column justify-content-center flex-md-row justify-content-md-around">
                                <button class="btn btn-danger m-1" ${deleteAction} ${params}>
                                    <i class="mdi mdi-delete-forever"></i>Eliminar
                                </button>
                            </div>`;
                        }
                        return data;
                    },
                    orderable: false,
                    searchable: false,
                    width: "10rem",
                },
            ];
            if (this.hasTitlesValue) {
                Object.entries(this.titlesValue).forEach(([columnName, title]) => {
                    const idx = columns.findIndex((column) => {
                        if (columnName === "_") {
                            return column.data === null;
                        }
                        return column.data === columnName;
                    });
                    if (idx !== -1) {
                        columns[idx].title = title;
                    }
                });
            }
            this.$datatable = $(this.table).DataTable({
                columns,
                ajax: this.fetchUrlValue,
                select: {
                    style: "single",
                    items: "row",
                },
                processing: true,
            });
            this.$datatable.on("select", () => {
                const selectedBank = this.$datatable
                    .row({ selected: true })
                    .data();
                if (selectedBank) {
                    this.dispatch("beginUpdate", {
                        detail: selectedBank,
                    });
                }
            });
            this.$datatable.on("deselect", () => {
                this.dispatch("bankSelectionCleared");
            });
        }
    }
    requestDelete(event) {
        const row = this.findRowByBankId(event.params.id);
        if (row.any()) {
            this.dispatch("beginDelete", {
                detail: {
                    bank: row.data(),
                    initiator: event.target,
                },
            });
        }
    }
    reload(event) {
        this.$datatable.ajax.reload(() => {
            if (event.detail) {
                const row = this.findRowByBankId(event.detail.id);
                if (row.any()) {
                    row.show().select().draw(false);
                }
            }
        });
    }
    removeSelection() {
        this.$datatable.rows().deselect();
    }
    disconnect() {
        if (this.isDTInitialized) {
            this.$datatable.destroy();
            this.isDTInitialized = false;
        }
    }
    findRowByBankId(bankId) {
        return this.$datatable.row((idx, data) => data.id === bankId);
    }
}
default_1.classes = ["imagePreview"];
default_1.targets = ["table"];
default_1.values = {
    fetchUrl: String,
    titles: Object,
};
//# sourceMappingURL=table_controller.js.map